(ns common.schema.entities.intelligence-data
  (:require
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (vec (concat (su/keyword-field
                :intelligence-data/source
                "intelligence data source type"
                nil
                (system-controlled {:authorization su/access-system-ssg}))
               (su/keyword-field
                :intelligence-data/entity-type
                "intelligence data entity type"
                nil
                (system-controlled {:authorization su/access-system-ssg}))
               (su/text-simple-field
                :intelligence-data/uuid
                "intelligence data source-id"
                (system-controlled {:authorization su/access-system-ssg}))
               (su/text-simple-multi-field
                :intelligence-data/query-string
                "Intelligence data - matched query argument"
                (system-controlled {:authorization su/access-system-ssg}))
               (su/text-simple-field
                :intelligence-data/domain
                "string used for matching company intelligence"
                (system-controlled {:authorization su/access-system-ssg}))
               (su/text-simple-field
                :intelligence-data/email
                "string used for matching person intelligence"
                (system-controlled {:authorization su/access-system-ssg}))

               (su/text-edn-field :intelligence-data/raw-data
                                  "Raw intelligence data in EDN serialization"
                                  (system-controlled {:authorization su/access-system-ssg})))))
